import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const SettingsContent = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/marketing_campaigns'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'marketing_campaigns_index',
          component: SettingsContent,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
